import { render, staticRenderFns } from "./policyManagement.vue?vue&type=template&id=6233c97c&"
import script from "./policyManagement.vue?vue&type=script&lang=js&"
export * from "./policyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6233c97c')) {
      api.createRecord('6233c97c', component.options)
    } else {
      api.reload('6233c97c', component.options)
    }
    module.hot.accept("./policyManagement.vue?vue&type=template&id=6233c97c&", function () {
      api.rerender('6233c97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/policyManagement.vue"
export default component.exports